module.exports = __webpack_public_path__ + "03_bob_brown.e157a382.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/03_bob_brown.png
// module id = /FUJ
// module chunks = 0